





















































































































import { AchievementType } from '@/models';
import { Actions } from '@/store';
import { resetModel, ToastsService, getImage, getImageType } from '@/utils';
import Vue from 'vue';
import { SelectAchievementImageModal } from '@/components/admin-panel/achievements';
import { Size, EditAchievementForm } from '@/models/admin-panel';

export default Vue.extend({
  name: 'EditAchievementModal',
  props: {
    achievement: Object as () => AchievementType,
  },
  components: {
    SelectAchievementImageModal,
  },
  data() {
    return {
      loader: {
        isRequestPending: false,
      },
      form: {
        name: '',
        description: '',
        url: '',
        iconFile: null as unknown as Blob,
      },
    };
  },
  computed: {
    imageMdSize(): Size {
      return {
        width: 125,
        height: 125,
      } as Size;
    },
    imageSmSize(): Size {
      return {
        width: 50,
        height: 50,
      } as Size;
    },
  },
  methods: {
    async setAchievement() {
      this.form = {
        name: this.achievement.name,
        description: this.achievement.description,
        url: this.achievement.imageUrl,
        iconFile: await this.getBlob(),
      };
    },
    async editAchievement() {
      const valid = await this.$validator.validate();

      if (!valid) {
        return;
      }

      this.loader.isRequestPending = true;
      const reader = new FileReader();
      reader.readAsDataURL(this.form.iconFile);
      reader.onloadend = async () => {
        try {

          const formData: EditAchievementForm = {
            id: this.achievement.id,
            name: this.form.name,
            description: this.form.description,
            image: {
              bytes: getImage(reader.result as string),
              imageType: getImageType(this.form.iconFile.type),
            },
            imageMdSize: this.imageMdSize,
            imageSmSize: this.imageSmSize,
            languageCode: this.$i18n.locale,
          };

          await this.$store.dispatch(Actions.achievements.editAchievement, formData);
          ToastsService.success(this.$t('admin-panel.achievements.tabs.types.achievement-edited-toast') as string);
          this.resetModels();
          this.$bvModal.hide('edit-achievement-modal');
          this.$emit('refresh');
        } finally {
          this.loader.isRequestPending = false;
        }
      };
    },
    openUploadModal() {
      this.$bvModal.show('select-achievement-image-modal');
    },
    async onAchievementImageSelected(value: Promise<Blob>) {
      const blob = await value;

      this.form.iconFile = blob;
      this.form.url = URL.createObjectURL(blob);
    },
    resetModels() {
      this.form = resetModel(this.form);
      this.form.url = '';

      requestAnimationFrame(async () => await this.$validator.reset());
    },
    async getBlob(): Promise<Blob> {
      const imgType = this.achievement.imageUrl.split('.').pop();

      return await fetch(this.achievement.imageUrl).then(r => r.blob());
    },
  },
});
